export const PRICE_RANGES = [
  { from: 0.01, to: 4.99, cvr: 35 },
  { from: 5, to: 9.99, cvr: 30 },
  { from: 10, to: 14.99, cvr: 25 },
  { from: 15, to: 19.99, cvr: 20 },
  { from: 20, to: 24.99, cvr: 15 },
  { from: 25, to: 29.99, cvr: 14 },
  { from: 30, to: 34.99, cvr: 13 },
  { from: 35, to: 39.99, cvr: 12 },
  { from: 40, to: 44.99, cvr: 11 },
  { from: 45, to: 49.99, cvr: 10 },
  { from: 50, to: 54.99, cvr: 9.5 },
  { from: 55, to: 59.99, cvr: 9 },
  { from: 60, to: 64.99, cvr: 8.5 },
  { from: 65, to: 69.99, cvr: 8 },
  { from: 70, to: 74.99, cvr: 7.5 },
  { from: 75, to: 79.99, cvr: 7 },
  { from: 80, to: 84.99, cvr: 6.5 },
  { from: 85, to: 89.99, cvr: 6 },
  { from: 90, to: 94.99, cvr: 5.5 },
  { from: 95, to: 99.99, cvr: 5 },
  { from: 100, to: 199.99, cvr: 4.5 },
  { from: 200, to: 299.99, cvr: 3 },
  { from: 300, to: 399.99, cvr: 2.75 },
  { from: 400, to: 499.99, cvr: 2.5 },
  { from: 500, to: 599.99, cvr: 2.25 },
  { from: 600, to: 699.99, cvr: 2 },
  { from: 700, to: 799.99, cvr: 1.75 },
  { from: 800, to: 899.99, cvr: 1.5 },
  { from: 900, to: 999.99, cvr: 1.25 },
  { from: 1000, to: Number.POSITIVE_INFINITY, cvr: 1 },
]
